<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <div
        v-if="loaded"
        class="flex"
      >
        <div class="md:w-1/2">
          <UnreadNotifications :notifications="unreadNotifications" />
        </div>
        <div class="md:w-1/2">
          <ReadNotifications />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import UnreadNotifications from './UnreadNotifications'
import ReadNotifications from './ReadNotifications'

export default {
  name: 'NotificationFeed',
  components: {
    UnreadNotifications,
    ReadNotifications,
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      unreadNotifications: state => state.notification.unread.data,
      readNotifications: state => state.notification.read.data,
    }),
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
      .then(() => {
        this.loaded = true
      })
  },
  methods: {
    ...mapActions({
      fetch: 'notificationGetNotifications',
    }),
  },
}
</script>
